import { Action } from '@ngrx/store';
import { RequestHistory, RequestFile, RequestCharge, RequestFeedback, PaginationModel, PagedResult } from '@app/core';

export enum RequestActionTypes {
  LoadRequestHistory = '[App Request] Load Request History',
  LoadRequestHistorySuccess = '[App Request] Load Request History Success',
  LoadRequestHistoryFail = '[App Request] Load Request History Success Fail',

  LoadRequestFiles = '[App Request] Load Request Files',
  LoadRequestFilesSuccess = '[App Request] Load Request Files Success',
  LoadRequestFilesFail = '[App Request] Load Request Files Success Fail',

  LoadRequestCharge = '[App Request] Load Request Charge',
  LoadRequestChargeSuccess = '[App Request] Load Request Charge Success',
  LoadRequestChargeFail = '[App Request] Load Request Charge Fail',

  DownloadFileByPath = '[App Request] Download File By Path',

  AddRequestFeedback = '[App Request] Add Request Feedback',
  AddRequestFeedbackSuccess = '[App Request] Add Request Feedback Success',
  AddRequestFeedbackFail = '[App Request] Add Request Feedback Fail',

  LoadRequestFeedbacks = '[App Request] Load Request Feedbacks',
  LoadRequestFeedbacksSuccess = '[App Request] Load Request Feedbacks Success',
  LoadRequestFeedbacksFail = '[App Request] Load Request Feedbacks Success Fail',
}

export class LoadRequestHistory implements Action {
  readonly type = RequestActionTypes.LoadRequestHistory;
  constructor(public payload: number) { }
}

export class LoadRequestHistorySuccess implements Action {
  readonly type = RequestActionTypes.LoadRequestHistorySuccess;
  constructor(public payload: RequestHistory[]) { }
}

export class LoadRequestHistoryFail implements Action {
  readonly type = RequestActionTypes.LoadRequestHistoryFail;
  constructor(public payload: any) { }
}

export class LoadRequestFiles implements Action {
  readonly type = RequestActionTypes.LoadRequestFiles;
  constructor(public payload: number) { }
}

export class LoadRequestFilesSuccess implements Action {
  readonly type = RequestActionTypes.LoadRequestFilesSuccess;
  constructor(public payload: RequestFile[]) { }
}

export class LoadRequestFilesFail implements Action {
  readonly type = RequestActionTypes.LoadRequestFilesFail;
  constructor(public payload: any) { }
}

export class LoadRequestCharge implements Action {
  readonly type = RequestActionTypes.LoadRequestCharge;
  constructor(public payload: number) { }
}

export class LoadRequestChargeSuccess implements Action {
  readonly type = RequestActionTypes.LoadRequestChargeSuccess;
  constructor(public payload: RequestCharge[]) { }
}

export class LoadRequestChargeFail implements Action {
  readonly type = RequestActionTypes.LoadRequestChargeFail;
  constructor(public payload: any) { }
}


export class DownloadFileByPath implements Action {
  readonly type = RequestActionTypes.DownloadFileByPath;
  constructor(public payload: string) { }
}

export class AddRequestFeedback implements Action {
  readonly type = RequestActionTypes.AddRequestFeedback;
  constructor(public payload: RequestFeedback) { }
}

export class AddRequestFeedbackSuccess implements Action {
  readonly type = RequestActionTypes.AddRequestFeedbackSuccess;
  constructor(public payload: RequestFeedback) { }
}

export class AddRequestFeedbackFail implements Action {
  readonly type = RequestActionTypes.AddRequestFeedbackFail;
  constructor(public payload: any) { }
}

export class LoadRequestFeedbacks implements Action {
  readonly type = RequestActionTypes.LoadRequestFeedbacks;
  constructor(public payload: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }) {}
}

export class LoadRequestFeedbacksSuccess implements Action {
  readonly type = RequestActionTypes.LoadRequestFeedbacksSuccess;
  constructor(public payload: PagedResult<RequestFeedback>) { }
}

export class LoadRequestFeedbacksFail implements Action {
  readonly type = RequestActionTypes.LoadRequestFeedbacksFail;
  constructor(public payload: any) { }
}



export type RequestActions =
  | LoadRequestHistory
  | LoadRequestHistorySuccess
  | LoadRequestHistoryFail

  | LoadRequestFiles
  | LoadRequestFilesSuccess
  | LoadRequestFilesFail

  | LoadRequestCharge
  | LoadRequestChargeSuccess
  | LoadRequestChargeFail

  | DownloadFileByPath

  | AddRequestFeedback
  | AddRequestFeedbackSuccess
  | AddRequestFeedbackFail

  | LoadRequestFeedbacks
  | LoadRequestFeedbacksSuccess
  | LoadRequestFeedbacksFail
  ;



// WEBPACK FOOTER //
// ./src/app/core/store/actions/request.actions.ts